import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import App from './App.vue';
import router from './router';
import stores from './store';
import { createHead, useSeoMeta } from '@vueuse/head'
import '@/assets/fontAwesome/scss/font-awesome.scss'
import '@/assets/css/font.scss'

const app = createApp(App);
const head = createHead()
app.use(head)
app.use(ElementPlus);
app.use(router);
app.use(stores);

//跳转前设置title
router.beforeEach((to, from, next) => {

  const { title, keywords, description } = to.meta;
  if (title) {
    document.title = title;
  }
  if (keywords) {
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.content = keywords;
    } else {
      const newMeta = document.createElement('meta');
      newMeta.setAttribute('name', 'keywords');
      newMeta.setAttribute('content', keywords);
      document.head.appendChild(newMeta);
    }
  }
  if (description) {
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.content = description;
    } else {
      const newMeta = document.createElement('meta');
      newMeta.setAttribute('name', 'description');
      newMeta.setAttribute('content', description);
      document.head.appendChild(newMeta);
    }
  }

  const siteName = '桃桃西雅图第一伴君品牌'
  useSeoMeta({
    title: `${title}`, // 浏览器标签
    ogTitle: title, // iOS/微信分享主标题（中文）
    ogDescription: '西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所,西雅图桃桃私人会所是西雅图私人高级会所之一,你都可以在我们的网站找到你想要的享受。',
    ogImage: 'https://seattletaotao.com/favicon.ico',
    ogSiteName: siteName,
  })

  next();
});
//跳转后设置scroll为原点
router.afterEach((to, from) => {
  window.scrollTo(0, 0);
  console.log("======" + from.path + to.path);
});

app.config.globalProperties.$local = window.localStorage;
app.config.globalProperties.$session = window.sessionStorage;

app.mount('#app');